import { Component, ContentChildren, OnInit, QueryList, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LeadIdInput } from '../../../shared/models/lead/leadId.input';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-view-html-modal',
  templateUrl: './view-html-modal.component.html',
  styleUrls: []
})
export class ViewHtmlModalComponent implements OnInit {

  @ViewChild('content', { static: false }) content: Element;
  leadRawHtml: string;
  leadSubject: string;
  @ContentChildren('a', { descendants: true }) links: QueryList<any>;
  loadingData = true;
  leadRawText: string;

  constructor(private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly modalsHandler: ModalsHandlerService
  ) { }

  ngOnInit(): void {
    this.modalsHandler.viewHtmlLeadModal.subscribe(leadId => {
      this.loadingData = true;
      this.leadRawHtml = '';
      this.leadSubject = '';
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        }).result.finally(() => {
          this.leadRawHtml = '';
          this.leadRawText = '';
          this.leadSubject = '';
        });
      const leadIdInput = new LeadIdInput();
      leadIdInput.leadId = leadId;
      this.leadService.getRawHtml$(leadIdInput).subscribe(res => {
        if (res.rawHtml) {
          this.leadRawHtml = res.rawHtml.replace(/href/g, 'target="_blank" href');
        }
        if (res.rawHtml && res.rawHtml.indexOf('href="www') !== -1) {
          this.leadRawHtml = res.rawHtml.replace(/href="www/g, 'target="_blank" href="http://www');
        }

        this.leadRawText = res.rawText;
        this.leadSubject = res.emailSubject;
        this.loadingData = false;
      });
    });
  }
}
